import http from 'hub-http/clients/apiClient';
import { sanitizeProperties } from 'reporting-snowflake/funnel/utils/properties';
export const fetchPropertiesByObjectTypeId = async objectTypeId => {
  const properties = await http.get(`sql-reporting/v1/extended-reportable-options/properties/${objectTypeId}`);
  return sanitizeProperties(properties);
};